// 9fbef606107a605d69c0edbcd8029e5d
import { createSelector } from 'reselect';
import { getABtestFromState, getAPIConfig } from '@tcp/core/src/utils';
import {
  getLabelFromCopyOrFromTranslation,
  getDynamicLabelValues,
} from '@tcp/core/src/utils/labels/labelUtilty';
import { RECOMMENDATIONS_REDUCER_KEY } from '../../../../../constants/reducer.constants';
import { HIDDEN_MBOX_NAME } from './Recommendations.constants';
import {
  lblErrorOptimisticAddtobag,
  RecommendationLabels,
  GLOBAL_RECOMMENDATIONS,
} from './Recommendations.labels';

const recommLabels = getLabelFromCopyOrFromTranslation(
  GLOBAL_RECOMMENDATIONS,
  RecommendationLabels
);

export const getProducts = (state, reduxKey) => {
  const recommendation = state[RECOMMENDATIONS_REDUCER_KEY];
  return recommendation && recommendation.get(reduxKey) && recommendation.get(reduxKey).products;
};

export const getTrendingProductsLoader = (state, reduxKey) => {
  const recommendation = state[RECOMMENDATIONS_REDUCER_KEY];
  return (recommendation && recommendation.get(reduxKey)?.isLoader) || false;
};

export const isTrendingProducts = (state, reduxKey) => {
  const recommendation = state[RECOMMENDATIONS_REDUCER_KEY];
  return (recommendation && recommendation.get(reduxKey)?.trendingData) || false;
};

export const getCompleteRecommendations = (state) => {
  return state[RECOMMENDATIONS_REDUCER_KEY];
};

export const getAppFirstSuggestedProduct = (state) => {
  const productsObj =
    state[RECOMMENDATIONS_REDUCER_KEY] &&
    state[RECOMMENDATIONS_REDUCER_KEY].get('favorites_global_products');
  return (
    (productsObj &&
      productsObj.products &&
      productsObj.products.length > 0 && [productsObj.products[0]]) ||
    null
  );
};

export const getFirstSuggestedProduct = (state, itemPartNumber) => {
  const productsObj =
    state[RECOMMENDATIONS_REDUCER_KEY] &&
    state[RECOMMENDATIONS_REDUCER_KEY].get('favorites_global_products');
  return (
    (productsObj &&
      itemPartNumber &&
      productsObj[itemPartNumber] &&
      productsObj[itemPartNumber].products &&
      productsObj[itemPartNumber].products.length > 0 && [
        productsObj[itemPartNumber].products[0],
      ]) ||
    null
  );
};

export const getSimilarItemToConsiderFromRecommendation = (recommendationProducts = []) => {
  return recommendationProducts.find((item) => item.isSimilarItemtoConsider === true);
};

export const getSuggestedProductState = (state, itemPartNumber) => {
  const productsObj =
    state[RECOMMENDATIONS_REDUCER_KEY] &&
    state[RECOMMENDATIONS_REDUCER_KEY].get('favorites_global_products');

  return !!(
    productsObj &&
    itemPartNumber &&
    productsObj[itemPartNumber] &&
    productsObj[itemPartNumber].products &&
    productsObj[itemPartNumber].products.length > 0
  );
};

export const getSuggestedProductErrors = (state, itemPartNumber) => {
  const productsObj =
    state[RECOMMENDATIONS_REDUCER_KEY] &&
    state[RECOMMENDATIONS_REDUCER_KEY].get('favorites_global_products');

  return (
    (productsObj &&
      itemPartNumber &&
      productsObj[itemPartNumber] &&
      productsObj[itemPartNumber].errors) ||
    {}
  );
};

export const getLoadedProductsCount = createSelector(
  getProducts,
  (products) => products && products.length
);

// TODO Labels -- Recommendation Module | Adding copy method till dependecy is cleared from all files
export const getLabelsProductListingCopy = (plpLabels) => {
  if (!plpLabels)
    return {
      addToBag: {},
      readMore: {},
      readLess: {},
    };
  const {
    plpTiles: {
      lbl_add_to_bag: addToBag,
      lbl_plp_in_multi_grid_header: inMultiGridHeader,
      lbl_plp_in_grid_description: inGridDescription,
      lbl_plp_in_multi_grid_description: inMultiGridDescription,
    } = {},
    seoText: { lbl_read_more: readMore, lbl_read_less: readLess } = {},
  } = plpLabels;

  return {
    addToBag,
    readMore,
    readLess,
    inGridDescription,
    inMultiGridHeader,
    inMultiGridDescription,
  };
};

export const getRecommendationsAbTest = (state, isAddedToBag) => {
  let abTest = null;
  const getAbtests = getABtestFromState(state.AbTest);

  if (getAbtests) {
    if (isAddedToBag && getAbtests.addedToBagModal) {
      abTest = getAbtests.addedToBagModal.recommendations;
    } else if (getAbtests.recommendations) {
      abTest = getAbtests.recommendations;
    }
  }
  return abTest;
};

export const getRecommendationModulePLabel = (
  abTestConfig,
  labelSuffix,
  ownProps,
  isOptimisticModalWithError = false
) => {
  if (isOptimisticModalWithError) {
    return recommLabels[lblErrorOptimisticAddtobag];
  }
  return abTestConfig
    ? recommLabels[`lbl_carousel_${labelSuffix}`]
    : ownProps.headerLabel || getDynamicLabelValues('dynamic.home.MODULE_P_HEADER_LABEL');
};

// TODO Labels- ModulesOHeaderLabel & modulePHeaderLabel are being passed via selector
export const getRecommendationModuleOLabel = (
  abTestConfig,
  labelSuffix,
  ownProps,
  isOptimisticModalWithError = false
) => {
  if (isOptimisticModalWithError) {
    return recommLabels[lblErrorOptimisticAddtobag];
  }
  return abTestConfig
    ? recommLabels[`lbl_carousel_${labelSuffix}`]
    : ownProps.headerLabel || getDynamicLabelValues('dynamic.home.MODULE_O_HEADER_LABEL');
};

export const getABTestConfig = (abTestRecommendations, ownProps) => {
  const carouselSequence = ownProps.sequence || '1';
  const carousel = `carousel${carouselSequence}`;
  return abTestRecommendations[`${carousel}`];
};

export const getMboxName = (abTestConfig) => {
  return abTestConfig && abTestConfig.hide ? HIDDEN_MBOX_NAME : abTestConfig.mbox;
};

export const getLabelSuffix = (page, ownProps, abTestRecommendations) => {
  const segment = abTestRecommendations.segment || 'A';
  const carouselSequence = ownProps.sequence || '1';
  return `${carouselSequence}_${page}_segment_${segment}`;
};

export const getMonetateEnabledFlag = () => {
  const apiConfigObj = getAPIConfig();
  let { monetateEnabled } = apiConfigObj;
  try {
    monetateEnabled = JSON.parse(monetateEnabled);
  } catch (e) {
    monetateEnabled = true;
  }
  return monetateEnabled;
};

export const getUpdateFlag = (state) => {
  return state[RECOMMENDATIONS_REDUCER_KEY] && state[RECOMMENDATIONS_REDUCER_KEY].get('isUpdating');
};

export const getRecommendationOrderModalState = (state) => {
  const orderRecommendationModal =
    state[RECOMMENDATIONS_REDUCER_KEY] &&
    state[RECOMMENDATIONS_REDUCER_KEY].get('orderRecommendationModal');
  return (orderRecommendationModal && orderRecommendationModal.isOpen) || false;
};

export const getRecommendationOrderPartNumbers = (state) => {
  const orderRecommendationModal =
    state[RECOMMENDATIONS_REDUCER_KEY] &&
    state[RECOMMENDATIONS_REDUCER_KEY].get('orderRecommendationModal');
  return (orderRecommendationModal && orderRecommendationModal.partNumbers) || [];
};

export const getRecommendationLoadingState = (state) => {
  return state[RECOMMENDATIONS_REDUCER_KEY] && state[RECOMMENDATIONS_REDUCER_KEY].get('isLoading');
};

export const getPushNotificationTestingFlag = () => {
  const apiConfigObj = getAPIConfig();
  let { pushNotificationTesting } = apiConfigObj;
  try {
    pushNotificationTesting = JSON.parse(pushNotificationTesting);
  } catch (e) {
    pushNotificationTesting = false;
  }
  return pushNotificationTesting;
};

const getRecommendationProducts = (
  state,
  ownProps,
  ooSItemIdWhoseSuggestionRequested,
  reduxKey
) => {
  let { page } = ownProps;
  if (page === 'home page') page = 'homepage';
  if (reduxKey.includes('hp')) page = reduxKey;
  if (ownProps?.unbxdNewArrivals) page = `${page}-unbxd`;

  const MONETATE_ENABLED = getMonetateEnabledFlag();

  let products = [];
  if (MONETATE_ENABLED === true) {
    products = ownProps.isSuggestedItem
      ? getFirstSuggestedProduct(state, ooSItemIdWhoseSuggestionRequested)
      : getProducts(state, page || 'homepageTest');
  } else {
    products = ownProps.isSuggestedItem
      ? getFirstSuggestedProduct(state, ooSItemIdWhoseSuggestionRequested)
      : getProducts(state, reduxKey);
  }
  return products;
};

export const getRecommendationProductsSelector = createSelector(
  getRecommendationProducts,
  (products) => {
    let data = [];
    if (products) {
      data = products;
    }
    return data;
  }
);
